import {
  HTTP_STATUS_INTERNAL_SERVER_ERROR,
  HTTP_STATUS_NOT_FOUND,
} from '../../../constants/api'
import { FILTER_NAME_SUB_MENU } from '../../../constants/filter'
import { PAGINATION_ALL_ITEMS_SIZE } from '../../../constants/pagination'
import { PAGE_SIZE_PARAM_KEY } from '../../../constants/route'
import { getSubSearchParam } from '../../../utils/route'
import { getEmailMessages, getEmailThreadProfile } from '../Email.api'

export async function emailThreadProfilePrintDataLoader({ params, request }) {
  const { mailUuid } = params
  const url = new URL(request.url)
  const sub = getSubSearchParam(url.searchParams)

  try {
    const [threadRes, messagesRes] = await Promise.all([
      getEmailThreadProfile({ uuid: mailUuid }),
      getEmailMessages({
        params: {
          ...(sub ? { [FILTER_NAME_SUB_MENU]: sub } : null),
          [PAGE_SIZE_PARAM_KEY]: PAGINATION_ALL_ITEMS_SIZE,
          email_thread_uuid: mailUuid,
        },
      }),
    ])

    const thread = threadRes?.data
    const messages = messagesRes?.data?.items

    if (!thread || !messages) {
      throw new Response('Thread not found', { status: HTTP_STATUS_NOT_FOUND })
    }

    return {
      ...thread,
      messages,
    }
  } catch (error) {
    if (error instanceof Response) {
      throw error
    }

    const status = error?.response?.status ?? HTTP_STATUS_INTERNAL_SERVER_ERROR
    const message =
      error?.response?.data?.message ??
      error?.message ??
      'Failed to load thread data'

    throw new Response(message, { status })
  }
}
